// Date/time formatting helpers — dd/mm/yyyy and AM/PM throughout the app.

function _parse(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value) ? null : value;
  // Mongo/Pydantic gives ISO 8601 string; native Date handles it.
  const d = new Date(value);
  return isNaN(d) ? null : d;
}

function _pad(n) { return n < 10 ? `0${n}` : `${n}`; }

export function fmtDate(value) {
  const d = _parse(value);
  if (!d) return "—";
  return `${_pad(d.getDate())}/${_pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function fmtTime(value) {
  const d = _parse(value);
  if (!d) return "—";
  let h = d.getHours();
  const m = _pad(d.getMinutes());
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${_pad(h)}:${m} ${ampm}`;
}

export function fmtDateTime(value) {
  const d = _parse(value);
  if (!d) return "—";
  return `${fmtDate(d)} · ${fmtTime(d)}`;
}

// Group custom fields by their section attribute. Defaults to "Custom".
export function groupBySection(fields) {
  const groups = {};
  for (const f of fields || []) {
    const key = f.section?.trim() || "Custom";
    if (!groups[key]) groups[key] = [];
    groups[key].push(f);
  }
  return groups;
}
